import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, message, Row, Spin, Tabs} from 'antd';
import ProForm, {ProFormInstance} from '@ant-design/pro-form';
import {BOHQ} from '@/services/mdm/bohq';
import {FileUploadUtility, WdiFileList} from '@/components/WdiControls/WdiFileUpload';
import {FormBudgetProjectDetail} from '@/services/sales/bp/formBudgetProject';
import TabPane from '@ant-design/pro-card/lib/components/TabPane';
import DynamicInformation from '../../components/DynamicInformation';
import BudgetInformation from '../../components/BudgetInformation';
import {FormPageProps, WdiFormPageTitle} from '@/components/WdiBus/FormPage';
import {initApprovalPageContext, ViewEntityProps} from '../../components/data';
import {ResponseStatus} from '@/utils/request';
import DataStore from '@/components/GridWidget/DataStore';
import {DataOptions} from '@/services/basic/metadata';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {WdiCardTitle, wdiCore, WdiInput, WdiStaffCard, WdiTextArea,} from '@/components/WdiControls';
import {FormBPDetailsForApprovalPanel} from '../../GeneralProjectApply/components/details';
import {EC} from '@/services/mdm/ec';
import {Product} from '@/services/mdm/product';
import {Enum} from '@/enums/system';
import {Channel} from '@/services/mdm/channel';
import {ShopLevel} from '@/services/mdm/shoplevel';
import {SoldTo} from '@/services/mdm/soldto';
import {CustSys} from '@/services/mdm/custsys';
import {Staff} from '@/services/basic/staff';
import {WdiEditor} from "@/components/WdiControls/WdiEditor";

const moreConfig: any = {
  successParams: [
    {
      url: '/basicapi/favorite/getButtons',
      keys: [],
    },
    {
      url: '/expenseapi/buttons/get',
      keys: ['UndoButton', 'ReeditButton', 'InterveneFlowButton', 'AppendExtNodeButton', 'AddMailApproverButton', 'ExpediteFlowButton', "FormSpPrintButton"],
    },
  ],
  errorParams: [
    {
      url: '/expenseapi/buttons/get',
      keys: ['RepairButton', 'InterveneFlowButton'],
    },
  ],
};

const approvalConfig: any = {
  params: {
    url: "/expenseapi/buttons/get",
    keys: [
      "ApprovalButton",
      "ReadButton",
    ]
  }
};

const FormBudgetProjectApprovalApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [entity, setEntity] = useState<ViewEntityProps>();
  const useCaseId = Enum.UseCase.BUDGET_PROJECT;
  const [activeKey, setActiveKey] = useState<string>("1");
  useEffect(() => {
    if (!formRef?.current) {
      return;
    }
    setActiveKey(props.data?.defaultActiveKey ?? "1");
  }, [!!(formRef?.current)])


  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initApprovalPageContext(params);

        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity: ViewEntityProps = result.data;
        const {formBudgetProject} = viewEntity;
        if (viewEntity.formBudgetProject) {
          formRef.current?.setFieldsValue({
            projectName: formBudgetProject?.projectName,
            projectCode: formBudgetProject?.projectCode,
            projectDate: wdiCore.Date.Join(formBudgetProject?.projectStartDate, formBudgetProject?.projectEndDate),
            totalBudget: wdiCore.Number.AmountToString(formBudgetProject?.totalBudget),
            projectRemark: formBudgetProject?.projectRemark,
            fileInfo: FileUploadUtility.parse(formBudgetProject?.fileName, formBudgetProject?.filePath),
            applyDate: wdiCore.Date.Join(formBudgetProject?.applyStartDate, formBudgetProject?.applyEndDate),
            modifiedReason: viewEntity.formBudgetProject.modifiedReason,
          });
        }
        setEntity(viewEntity);

        if (formBudgetProject?.bohqId) {
          BOHQ.get(formBudgetProject.bohqId).then((response) => {
            formRef.current?.setFieldsValue({
              bohqName: response.data.bohqName
            });
          });
        }
        // if (formBudgetProject?.pageTypeId) {
        //   PageType.get(formBudgetProject.pageTypeId).then((response) => {
        //     formRef.current?.setFieldsValue({
        //       pageTypeName: response.data.pageTypeName
        //     });
        //   });
        // }
        // if (formBudgetProject?.projectApproverIds) {
        //   ApproverUserIds.fetchUserForDataSource(formBudgetProject?.projectApproverIds, (data) => {
        //     formRef.current?.setFieldsValue({
        //       projectApproverIds: data
        //     });
        //   });
        // }

        if (formBudgetProject?.limitedChannelIds) {
          Channel.search({channelIds: formBudgetProject.limitedChannelIds}).then(response => {
            if (response.data && response.data.length > 0) {
              formRef.current?.setFieldsValue({
                limitedChannelIds: response.data.map(channel => channel.codeOrName).join()
              });
            }
          });
        }

        if (formBudgetProject?.limitedEcIds) {
          EC.search({ecIds: formBudgetProject.limitedEcIds}).then((response) => {
            formRef.current?.setFieldsValue({
              limitedEcIds: response.data.map(item => item.ecName).join()
            });
          });
        }
        if (formBudgetProject?.limitedProductIds) {
          Product.searchAll({productIds: formBudgetProject.limitedProductIds}).then((response) => {
            formRef.current?.setFieldsValue({
              limitedProductIds: response.data.map(item => item.productName).join()
            });
          });
        }
        if (formBudgetProject?.limitedShopLevelIds) {
          ShopLevel.search({shopLevelIds: formBudgetProject.limitedShopLevelIds}).then(response => {
            if (response.data && response.data.length > 0) {
              formRef.current?.setFieldsValue({
                limitedShopLevelIds: response.data.map(shopLevel => shopLevel.codeOrName).join()
              });
            }
          });
        }

        if (formBudgetProject?.limitedSoldToCodes) {
          SoldTo.search({soldToCodes: formBudgetProject?.limitedSoldToCodes}).then(response => {
            if (response.data && response.data.length > 0) {
              formRef.current?.setFieldsValue({
                limitedSoldToCodes: response.data.map(soldTo => soldTo.codeOrName).join()
              });
            }
          });
        }
        if (formBudgetProject?.limitedCustSysCodes) {
          CustSys.search({custSysCodes: formBudgetProject?.limitedCustSysCodes}).then(response => {
            if (response.data && response.data.length > 0) {
              formRef.current?.setFieldsValue({
                limitedCustSysCodes: response.data.map(custSys => custSys.codeOrName).join()
              });
            }
          });
        }
        if (formBudgetProject?.limitedActivitySubjectIds) {
          DataOptions.search({
            typeGroup: 121,
            inValues: formBudgetProject?.limitedActivitySubjectIds
          }).then(response => {
            if (response.data && response.data.length > 0) {
              formRef.current?.setFieldsValue({
                limitedActivitySubjectIds: response.data.map(limitedActivity => limitedActivity.name).join()
              });
            }
          });
        }
        if (formBudgetProject?.projectApproverIds) {
          Staff.search({staffIds: formBudgetProject?.projectApproverIds}).then((response) => {
            formRef.current?.setFieldsValue({
              projectApproverIds: response.data
                .map((item) =>
                  wdiCore.String.GenerateLabelDescription(item.staffNoOrName, item.title),
                )
                .join(),
            });
          });
        }
        if (formBudgetProject) {
          FormBudgetProjectDetail.query(formBudgetProject?.formBudgetProjectId, formBudgetProject?.buId).then((response) => {
            setDataSource(DataStore.init(response.data));
          });
        }
      }
    })();
  }, [props.data]);

  useEffect(() => {
    if (props.setPageTitle && entity) {
      let title = `专项项目${entity.form?.relationType == Enum.FormRelationType.MODIFIED ? '修改' : '创建'}申请单【${entity.form?.formNo}】`;
      DataOptions.search({typeGroup: 3, value: entity.form?.statusId}).then(response => {
        if (response.code !== ResponseStatus.SUCCESS) {
          message.error(response.message);
          return;
        }
        if (response.data && response.data.length > 0) {
          title += `，${response.data[0].name}`;
          if (props.setPageTitle) props.setPageTitle(
            <WdiFormPageTitle
              title={title}
              onClose={props.onClose}
              callback={props.callback}
              form={entity?.form}
              useCaseId={Enum.UseCase.BUDGET_PROJECT}
              moreConfig={moreConfig}
              approvalConfig={approvalConfig}/>
          );
        }
      });
    }
  }, [props.setPageTitle, entity]);

  return (
    <>
      <WdiStaffCard formId={entity?.form?.formId}/>
      <Tabs activeKey={activeKey} onTabClick={(key, _) => setActiveKey(key)} size="large">
        <TabPane tab={<span>资料</span>} key="1">
          <ProForm
            formRef={formRef}
            submitter={{
              render: () => {
                return (<></>)
              },
            }}
          >
            <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.BASE_INFO} title='项目基本信息'/>} collapsed={true}>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="projectName" label="项目名称">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="projectCode" label="项目编号">
                    <WdiInput readOnly style={entity?.formBudgetProject?.budgetProjectId ? {
                      color: "#2299ee",
                      cursor: "pointer"
                    } : {}} onClick={() => {
                      if (entity?.formBudgetProject?.budgetProjectId) {
                        window.open(`/project/budgetprojectdisplay?budgetProjectId=${entity?.formBudgetProject?.budgetProjectId}`);
                      }
                    }}/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="projectDate" label="活动实际执行期间">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="totalBudget" label="项目总额">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="projectApproverIds" label="活动申请/核销附加审批人">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="bohqName" label="预算归属">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                {/*                <Col className="gutter-row" span={4}>
                  <Form.Item name="pageTypeName" label="单据类型">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>*/}


              </Row>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={16}>
                  <Form.Item name="projectRemark" label="方案简述">
                    <WdiEditor readOnly={true}/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                  <Form.Item
                    name="fileInfo"
                    label="附件"
                    valuePropName='fileList'
                    getValueFromEvent={(e: any) => {
                      return e.fileList || [];
                    }}
                  >
                    <WdiFileList
                      fileList={FileUploadUtility.parse(entity?.formBudgetProject?.fileName, entity?.formBudgetProject?.filePath)}/>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={16}
                     hidden={entity?.form?.relationType != Enum.FormRelationType.MODIFIED}>
                  <Form.Item name="modifiedReason" label="修改原因">
                    <WdiTextArea rows={4} readOnly/>
                  </Form.Item>
                </Col>
              </Row>
            </WdiPanel>
            <WdiPanel
              collapsed={true}
              title={<WdiCardTitle iconType={Enum.IconType.LIMITED_INFO} title='维度信息（对专项下的活动申请做限制）'/>}
            >
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="applyDate" label="专项费用可申请时间">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4} hidden={true}>
                  <Form.Item name="limitedProductIds" label="产品别维度">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4} hidden={true}>
                  <Form.Item name="limitedEcIds" label="费用项维度">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={4}>
                  <Form.Item name="limitedCustSysCodes" label="客户组维度">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="limitedSoldToCodes" label="客户维度">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="limitedActivitySubjectIds" label="活动主题维度">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
              </Row>
            </WdiPanel>
          </ProForm>
          <FormBPDetailsForApprovalPanel dataSource={dataSource}/>
        </TabPane>
        <TabPane tab={<span>预算信息</span>} key="2">
          <BudgetInformation formId={entity?.form?.formId}/>
        </TabPane>
        <TabPane tab={<span>动态信息</span>} key="3">
          {
            entity?.form ? <DynamicInformation
              formId={entity?.form?.formId}
              formTypeId={entity?.form?.formTypeId}
              pageTypeId={entity?.form?.pageTypeId}
              useCaseId={useCaseId}
            /> : <Spin/>
          }
        </TabPane>
      </Tabs>
    </>
  );
};
export default FormBudgetProjectApprovalApp;
